import { VictoryTooltip } from "victory";
import { colors, fonts } from "../../../../Styles";

export const ConsumptionTooltip = (
  <VictoryTooltip
    dy={-3}
    cornerRadius={8}
    pointerLength={6}
    pointerWidth={12}
    flyoutPadding={{ top: 1, bottom: 1, left: 6, right: 6 }}
    flyoutStyle={{
      fill: colors.greyDarkPrimary,
      stroke: 0
    }}
    style={{
      fill: colors.greyLightTertiary,
      fontSize: "11px",
      ...fonts.paragraph,
    }}
  />
)